import React from "react";
import {Link} from 'react-router-dom'

import Marketplace from "../../images/marketplace.svg";
import Farm from "../../images/farm.svg";
import Events from "../../images/events.svg";

import LazyLoad from 'react-lazyload';

const Features = () => {
  const items = [
    {
      img: Marketplace,
      link: "/marketplace",
      name: "Marketplace",
      description: "Marketplace is a place where you can buy and sell your NFTs."
    },
    {img: Farm, link: "/farm", name: "Farm", description: "Farm is a place where you can acquire new NFTs."},
    {
      img: Events,
      link: "/events",
      name: "Events",
      description: "See all the amazing events happening in the NiftyEggs universe."
    },
  ];

  const featureCards = items.map(item =>
    <div key={item.name} className="feature-card pt-5 pb-3 mb-5 d-flex flex-column">
      <LazyLoad once={true}>
        <img src={item.img} className="feature-image" alt={item.name}/>
      </LazyLoad>
      <h3 className="text-white">{item.name}</h3>
      <hr className="hr-line3"/>
      <p className="feature-text mb-3">{item.description}</p>
      <Link className="btn btn-secondary btn-scale mt-auto mx-auto" to={item.link}>Explore</Link>
    </div>
  );

  return (
    <section id="features">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 70" preserveAspectRatio="none">
        <rect x="1200" height="3.6"/>
        <rect height="3.6"/>
        <path fill="#353644" d="M0,0V3.6H580.08c11,0,19.92,5.09,19.92,13.2,0-8.14,8.88-13.2,19.92-13.2H1200V0Z"
              className="shape-fill"/>
      </svg>
      <div className="px-4 container-fluid">
        <div className="row no-gutters mb-5">
          <div className="col-10 offset-1 text-center">
            <h2>FEATURES</h2>
            <hr className="hr-line2"/>
          </div>
        </div>
        <div className="row no-gutters text-center mt-4 pb-5">
          <div className="feature-wrapper col">
            {featureCards}
          </div>
        </div>
      </div>
    </section>
  )
};

export default Features;